export class AssignmentDetails {
    AssignmentID: number;
    OrganizationID: number;
    StartDate: string;
    EndDate: string;
    ActivitySequence: ActivitySequenceDetails;
    AssignedStudents: AssignedStudent[];
}

export class ActivitySequenceDetails {
    ActivitySequenceID: number;
    Name: string;
    Activities: AssignedActivityDetail[];
}

export class AssignedActivityDetail {
    AssignedActivityID: string;
    ActivityID: string;
    UnitNumber: number;
    CategoryID?: number;
    MinTime?: number;
    MaxTime?: number;
    Title?: string;
    Level?: number;
    ExtraData?: string;
}

export class AssignedStudent {
    StudentID: number;
}